import { render } from "./AccountWarningCanceled.vue?vue&type=template&id=1c98f882"
import script from "./AccountWarningCanceled.vue?vue&type=script&lang=js"
export * from "./AccountWarningCanceled.vue?vue&type=script&lang=js"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__